export function advanceLoop(clock: number, duration: number, dt: number) {
  const next = clock + dt;
  return { clock: next % duration, cycles: Math.floor(next / duration) };
}
